import { type FC } from 'react';
import { ThemedLayout } from './ThemedLayout';
import { Outlet } from 'react-router';

const RootLayout: FC = () => {
  return (
    <ThemedLayout>
      <Outlet />
    </ThemedLayout>
  );
};

export default RootLayout;
